import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ContactForm from "./ContactForm";

const AddContact = ({ searchPrams, contactData, setContactData }) => {
  return (
    <div>
      <Grid container columnSpacing={3} sx={{}}>
        <Grid size={12} sx={{ mb: 4 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              width="119"
              height="123"
              viewBox="0 0 119 123"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.2124 54.0514C13.2124 54.0514 33.9825 53.2196 38.4709 19.078C42.4568 -11.2431 77.4807 2.55793 87.6048 14.6446C100.72 30.3019 93.7285 57.2358 110.694 60.6383C127.66 64.0408 116.581 101.871 90.8281 98.2499C58.7923 93.7456 66.5431 112.466 56.9261 120.389C50.0242 126.076 21.724 120.601 20.7808 99.9585C19.987 82.5877 12.6597 82.6428 7.46602 80.6731C-0.0244583 77.8324 -4.74428 57.2591 13.2124 54.0514Z"
                fill="#EEF2FF"
              />
              <path
                d="M83.8191 91.9686L63.4131 71.8047L59.3724 75.8939L79.7784 96.0578L83.8191 91.9686Z"
                fill="#818FF8"
              />
              <path
                d="M91.6142 97.3858L75.7383 81.6982C75.6499 81.6108 75.5074 81.6117 75.4201 81.7001L69.4112 87.7812C69.3238 87.8696 69.3247 88.012 69.4131 88.0994L85.289 103.787C85.3774 103.874 85.5199 103.873 85.6072 103.785L91.6161 97.7039C91.7035 97.6156 91.7026 97.4731 91.6142 97.3858Z"
                fill="#4B46E5"
              />
              <path
                d="M45.3271 81.9452C59.3659 81.9452 70.7465 70.5646 70.7465 56.5258C70.7465 42.4871 59.3659 31.1064 45.3271 31.1064C31.2884 31.1064 19.9078 42.4871 19.9078 56.5258C19.9078 70.5646 31.2884 81.9452 45.3271 81.9452Z"
                fill="#4B46E5"
              />
              <path
                d="M45.3271 77.7974C57.0752 77.7974 66.5989 68.2737 66.5989 56.5256C66.5989 44.7776 57.0752 35.2539 45.3271 35.2539C33.5791 35.2539 24.0554 44.7776 24.0554 56.5256C24.0554 68.2737 33.5791 77.7974 45.3271 77.7974Z"
                fill="#E0E8FF"
              />
              <path
                d="M88.3015 33.5469C82.339 31.6142 75.8954 34.8829 73.9549 40.87C72.0223 46.8325 75.2909 53.2761 81.278 55.2166C87.2651 57.157 93.6919 53.8563 95.625 47.8935C97.558 41.9307 94.2643 35.4795 88.3015 33.5469ZM86.5024 39.0976C87.1698 39.314 87.7579 39.7236 88.1922 40.2747C88.6264 40.8258 88.8872 41.4934 88.9415 42.1928C88.9958 42.8923 88.8411 43.5922 88.4971 44.2036C88.153 44.8151 87.6351 45.3106 87.0091 45.6273C86.3831 45.944 85.6771 46.0676 84.9807 45.9825C84.2843 45.8974 83.6288 45.6074 83.0975 45.1492C82.5661 44.6911 82.1828 44.0855 81.9962 43.4092C81.8095 42.7329 81.8279 42.0164 82.049 41.3506C82.6461 39.5084 84.66 38.5006 86.5024 39.0976ZM82.0008 52.9866C80.0199 52.3478 78.3226 51.0402 77.1997 49.2877C79.3009 48.0937 81.498 47.7612 83.4856 48.4054C85.4733 49.0497 87.0895 50.5913 88.0588 52.8073C86.1214 53.5679 83.9798 53.6313 82.0008 52.9866Z"
                fill="#6368F1"
              />
              <path
                d="M38.6738 87.8798C37.6381 88.4085 36.7825 89.2323 36.2151 90.2473C35.6476 91.2622 35.3939 92.4226 35.486 93.5817C35.5781 94.7409 36.0118 95.8467 36.7323 96.7593C37.4528 97.6719 38.4278 98.3504 39.5339 98.7089C40.6401 99.0674 41.8277 99.0899 42.9466 98.7734C44.0655 98.457 45.0654 97.8159 45.8199 96.9311C46.5744 96.0464 47.0496 94.9578 47.1855 93.803C47.3213 92.6481 47.1116 91.479 46.583 90.4433C45.8729 89.0558 44.6413 88.0066 43.1585 87.526C41.6757 87.0454 40.0629 87.1727 38.6738 87.8798ZM40.0431 90.5624C40.3657 90.3978 40.7299 90.3326 41.0895 90.3752C41.4492 90.4178 41.7881 90.5663 42.0632 90.8018C42.3384 91.0373 42.5373 91.3492 42.6349 91.698C42.7326 92.0468 42.7244 92.4167 42.6114 92.7608C42.4985 93.1049 42.2859 93.4077 42.0007 93.6308C41.7154 93.8539 41.3703 93.9873 41.0091 94.0139C40.6479 94.0406 40.2869 93.9594 39.972 93.7807C39.657 93.6019 39.4022 93.3336 39.24 93.0098C39.0249 92.5782 38.9886 92.0793 39.139 91.6211C39.2893 91.1629 39.6142 90.7825 40.0431 90.5622V90.5624ZM43.4694 97.2749C42.5132 97.7648 41.4165 97.907 40.367 97.6772C40.6981 96.4745 41.3787 95.5512 42.3395 95.0609C43.3003 94.5705 44.4527 94.5434 45.6153 94.9983C45.1856 95.983 44.427 96.7877 43.4694 97.2746V97.2749Z"
                fill="#6368F1"
              />
            </svg>
            {searchPrams && (
              <>
                <Typography variant="body2" sx={{ mt: 4 }}>
                  No contact found with
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {searchPrams}
                </Typography>
              </>
            )}
          </Box>
        </Grid>
        <Grid size={12}>
          <Typography
            variant="body1"
            sx={{ fontWeight: 600, mb: 3 }}
            onClick={() => {
              console.log("contactData", contactData);
            }}
          >
            Add Contact
          </Typography>
        </Grid>
        <ContactForm searchPrams={searchPrams} setContactData={setContactData} />
      </Grid>
    </div>
  );
};

export default AddContact;
